// pages/tasks/hooks/useNewTasks.ts
import { useState, useCallback } from "react";
import { Task } from "@/types";
import { TASK_PRIORITIES, TASK_STATUS, FREQUENCY_OPTIONS } from "@/utils/constants";

export const useNewTasks = () => {
  const [newTaskRows, setNewTaskRows] = useState<Partial<Task>[]>([]);

  const addNewTaskRow = useCallback(() => {
    if (newTaskRows.length < 5) {
      const tempId = `new-${Date.now()}-${Math.random()}`;
      const newTask: Partial<Task> = {
        tempId,
        client: "",
        task: "",
        subTask: "",
        et: 0,
        allottedTo: "",
        teamLeader: "",
        priority: TASK_PRIORITIES.MEDIUM,
        status: TASK_STATUS.TODO,
        frequency: FREQUENCY_OPTIONS.NONE,
        dueDate: new Date().toISOString(),
        tt: 0,
      };
      
      setNewTaskRows(prev => [...prev, newTask]);
    }
  }, [newTaskRows.length]);

  const handleNewTaskChange = useCallback((tempId: string, key: keyof Task, value: any) => {
    setNewTaskRows(prev => {
      const updated = prev.map(row => 
        row.tempId === tempId ? { ...row, [key]: value } : row
      );
      return updated;
    });
  }, []);

  return {
    newTaskRows,
    setNewTaskRows,
    addNewTaskRow,
    handleNewTaskChange,
  };
};